var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FC654A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7927 12.958V15.706C13.4466 15.6147 13.0845 15.6023 12.7329 15.6696C12.3814 15.7369 12.0494 15.8822 11.7615 16.0949C11.4736 16.3076 11.2371 16.5821 11.0695 16.8983C10.9018 17.2146 10.8072 17.5644 10.7927 17.922C10.7724 18.2303 10.8183 18.5395 10.9275 18.8285C11.0366 19.1176 11.2065 19.38 11.4255 19.5979C11.6446 19.8158 11.9078 19.9843 12.1975 20.092C12.4871 20.1996 12.7965 20.244 13.1047 20.222C13.4155 20.2456 13.7278 20.2015 14.0199 20.0928C14.312 19.984 14.5771 19.8132 14.7967 19.5921C15.0164 19.371 15.1856 19.1048 15.2924 18.812C15.3993 18.5192 15.4413 18.2067 15.4157 17.896V7H18.1347C18.5977 9.876 20.0347 10.544 21.9617 10.852V13.608C20.627 13.4989 19.3394 13.0642 18.2117 12.342V17.787C18.2097 20.25 16.7497 23 13.1247 23C12.4448 22.9969 11.7723 22.8581 11.1467 22.5918C10.521 22.3255 9.95485 21.937 9.48128 21.4491C9.00771 20.9612 8.63627 20.3836 8.38874 19.7503C8.1412 19.1171 8.02254 18.4407 8.03972 17.761C8.0611 17.0531 8.2323 16.3579 8.54204 15.721C8.85177 15.0842 9.293 14.5202 9.83662 14.0664C10.3802 13.6125 11.0139 13.2791 11.6958 13.088C12.3777 12.897 13.0924 12.8527 13.7927 12.958V12.958Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4d21ddef.svg";
export { ForwardRef as ReactComponent };